<template>
    <div class="VueTables__columns-dropdown-wrapper">

        <div :class="`${props.theme.dropdown.container} VueTables__columns-dropdown`">
            <button type="button" :class="`btn btn-default ${props.theme.dropdown.trigger}`" @click="props.toggleColumnsDropdown">

                {{ props.display('columns') }} {{ props.columns.length  }}/{{ props.origColumns.length }}

                <span :class="`${props.theme.icon} ${props.theme.small}`">
                    <i :class="props.theme.dropdown.caret"></i>
               </span>
            </button>
            <ul :class="props.theme.dropdown.menu" :style="props.displayColumnsDropdown ? 'display:block' : 'display:none'">
                <li v-for="column in props.origColumns">
                    <a :class="props.theme.dropdown.item" href="javascript:void(0)" @click="props.toggleColumn(column)">
                        <input type="checkbox" :value="column" :disabled="props.onlyColumn(column)" :checked="props.columns.includes(column)"/>
                        {{ props.getHeading(column) }}
                    </a>
                </li>
            </ul>

        </div>
    </div>
</template>

<script>
    export default {
        name: "CustomColumnDropdown",
        props: ['props'],
        opts: {
            right: 'float-md-right float-left'
        },

        computed: {
            visibleColumns(){
                return this.props.columns.length;
            }
        },

        mounted(){
            //console.log(this.props);
        },
    }
</script>